import { useState } from 'react';

import SignIn from './SignIn.jsx';
import ForgotPassword from './ForgotPassword.jsx';

// Unauthenticated entry point. Toggles between sign-in and forgot-password
// INITIATION. Web has no sign-up — that lives on the Halo mobile app — and the
// reset is finished on its own public route, /password-code.
export default function AuthScreen() {
  const [view, setView] = useState('signIn');
  // Becomes true after the first toggle, so focus only moves to a heading on a
  // deliberate view change — not on the initial gate render. (ForgotPassword
  // always mounts via a toggle, so it manages its own focus internally.)
  const [toggled, setToggled] = useState(false);

  const goTo = (next) => {
    setToggled(true);
    setView(next);
  };

  if (view === 'forgot') {
    return <ForgotPassword onBackToSignIn={() => goTo('signIn')} />;
  }
  return (
    <SignIn
      autoFocusHeading={toggled}
      onForgotPassword={() => goTo('forgot')}
    />
  );
}
